export default function Skeleton({ rows = 3, height = 72, testId = "skeleton" }) {
  return (
    <div className="space-y-2" data-testid={testId} aria-hidden>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton" style={{ height: `${height}px` }} />
      ))}
    </div>
  );
}
